module.exports = __webpack_public_path__ + "static/media/Jonas Brothers - Happiness Begins.956766f6.mp3";